<template>
  <div class="syllablestable table-container">
    <table class="syllablestablebody table">
      <template v-for="line in syllables[category]">
        <template v-for="n in levels">
          <tr :key="line[0] + n">
            <td
              class="syllables__td is-size-7-mobile  is-size-4"
              v-for="phone in line"
              :key="phone + n"
              @click="selectSign(phone, n)"
            >
              <template v-if="Object.values(syllables['syllables'][phone])[n]">
                <span class="sylllables__transliteral">{{
                  transliteral(phone, n)
                }}</span>
                <span class="sylllables__cuneiform" :class="cuneiformClass">{{
                  Object.values(syllables["syllables"][phone])[n]
                }}</span>
              </template>
            </td>
          </tr>
        </template>
        <tr :key="line[0] + '_'" class="syllables_divider"></tr>
      </template>
    </table>
  </div>
</template>

<script>
const table = require("@/data/syllables_table.json");
import DisplayTransLiteral from "../modules/Transliteral.js";

export default {
  props: {
    category: {
      type: String,
      requied: true
    },
    level: {
      type: Number,
      default: 3
    },
    cuneiformClass: {
      type: String,
      default: "akkadian"
    },
    transliteralStyle: String
  },
  computed: {
    syllables: function() {
      return table;
    },
    levels() {
      var result = [];
      for (let index = 0; index < this.level + 1; index++) {
        result.push(index);
      }
      return result;
    }
  },
  methods: {
    transliteral: function(base, number) {
      return DisplayTransLiteral(base + (number + 1), this.transliteralStyle);
    },
    selectSign(phone, n) {
      let sign = Object.values(table["syllables"][phone])[n];
      if (sign) {
        this.$emit("select", { sign: sign });
      }
    }
  }
};
</script>

<style lang="sass">
.syllablestable
    margin: 0 auto
.syllablestablebody
  margin: 0 auto

.syllables_divider
  height:15px

.syllables__td
  padding:2px

table.table td:hover
  background-color: #CCFFFF

span.sylllables__cuneiform
  margin:0px 5px
</style>
